import { useState } from 'react'

import AuthenticationMethodSelector from './AuthenticationMethodSelector'
import {
  authenticationKinds,
  configLastStepKind,
  directClientCredentialSteps,
  PMSSteps
} from './constants'
import DirectClientCredentials from './DirectClientCredentials'
import PendingEmailConfirmation from './EmailConfirmation'
import EnvironmentSetup from './EnvironmentSetup'
import FAQCard from './FAQ'
import styles from './MultiStepPMSLogin.module.scss'
import ohip from './ohip.png'
import oracle from './oracle.png'
import PartnerRegistration from './PartnerRegistration'
import PMSLoginSuccess from './PMSLoginSuccess'
import RegisterApiUser from './RegisterApiUser'
import ReviewAndFinalize from './ReviewAndFinalize'

const OHIPPMSLogin = ({ ohipConfigData, setIsOHIPConfigFinazized, setUpdateConfig }) => {
  const { authenticationKind, lastStep, tenantId, propertyId, hubId } = ohipConfigData
  const [selectedAuthenticationKind, setSelectedAuthenticationKind] = useState(null)
  const effectiveAuthenticationKind =
    authenticationKind === authenticationKinds.direct
      ? authenticationKind
      : selectedAuthenticationKind
  const isDirectClientCredentials =
    effectiveAuthenticationKind === authenticationKinds.direct
  const steps = isDirectClientCredentials ? directClientCredentialSteps : PMSSteps

  return (
    <div className={styles.wrapper}>
      {configLastStepKind[lastStep] !== 'Step6Completed' ? (
        <div className={styles.card}>
          <div className={styles.stepsGuide}>
            <div className={styles.logo}>
              <img className={styles.logoLeft} src={oracle} alt={'oracle'} />
              <img className={styles.logoRight} src={ohip} alt={'ohip'} />
            </div>
            <div className={styles.stepTitleContainer}>
              {steps.map(step => (
                <p
                  key={step.title}
                  className={
                    step.status === lastStep ? styles.selectedStep : styles.stepTitle
                  }
                >
                  {step.order}. {step.title}
                </p>
              ))}
            </div>
          </div>
          <div className={styles.stepsContainer}>
            {configLastStepKind[lastStep] === 'Step1PartnerRegistration' &&
              !selectedAuthenticationKind && (
                <AuthenticationMethodSelector onSelect={setSelectedAuthenticationKind} />
              )}
            {configLastStepKind[lastStep] === 'Step1PartnerRegistration' &&
              selectedAuthenticationKind === authenticationKinds.legacy && (
                <PartnerRegistration setUpdateConfig={setUpdateConfig} />
              )}
            {configLastStepKind[lastStep] === 'Step1PartnerRegistration' &&
              selectedAuthenticationKind === authenticationKinds.direct && (
                <DirectClientCredentials setUpdateConfig={setUpdateConfig} />
              )}
            {configLastStepKind[lastStep] === 'Step2ApiUserRegistration' && (
              <RegisterApiUser setUpdateConfig={setUpdateConfig} tenantId={tenantId} />
            )}
            {configLastStepKind[lastStep] === 'Step3EmailConfirmationPending' && (
              <PendingEmailConfirmation
                setUpdateConfig={setUpdateConfig}
                tenantId={tenantId}
              />
            )}
            {configLastStepKind[lastStep] === 'Step4EnvironmentSetup' && (
              <EnvironmentSetup setUpdateConfig={setUpdateConfig} tenantId={tenantId} />
            )}
            {configLastStepKind[lastStep] === 'Step5ReviewAndFinalize' && (
              <ReviewAndFinalize
                hubId={hubId}
                tenantId={tenantId}
                propertyId={propertyId}
                setIsOHIPConfigFinazized={setIsOHIPConfigFinazized}
                setUpdateConfig={setUpdateConfig}
                authenticationKind={authenticationKind}
              />
            )}
          </div>
        </div>
      ) : (
        <PMSLoginSuccess hubId={hubId} propertyId={propertyId} />
      )}
      {!isDirectClientCredentials &&
        (configLastStepKind[lastStep] === 'Step1PartnerRegistration' ||
          configLastStepKind[lastStep] === 'Step2ApiUserRegistration') && (
          <FAQCard selectedStep={lastStep} />
        )}
    </div>
  )
}

export default OHIPPMSLogin
